/** Termina il caricamento iniziale del box condiviso Informazioni gara. */
export function finishAuctionInfoLoading(): void {
    const box = document.querySelector<HTMLElement>('[data-auction-info][aria-busy="true"]');
    if (!box) return;
    // Evita skeleton permanenti in caso di risposta vuota, errore o termini scaduti.
    box.querySelectorAll<HTMLElement>('.placeholder').forEach(placeholder => {
        placeholder.parentElement?.replaceChildren(document.createTextNode('—'));
    });
    box.querySelectorAll<HTMLElement>('.placeholder-glow').forEach(field => field.classList.remove('placeholder-glow'));
    box.setAttribute('aria-busy', 'false');
}
